import axios from 'axios';
import router from '../router';

let state = {

    // Preselection traction sheave
    deliverTractionSheaveSelection: [],
    machiningForHandWheelSelection: [],
    tractionSheave_DiameterAndWidthSelection: [],
    sheaveProfileSelection: [],
    ropeDiameterSelection: [],
    undercutAngleSelection: [],
    vgrooveAngleSelection: [],
    grooveDistanceSelection: [],
    numberOfGroovesSelection: [],

    deliverTractionSheave: undefined,
    showTractionSheaveDetails: true,
    showInfoTractionSheave: false,
    machiningForHandWheel: undefined,
    tractionsheave_DiameterAndWidth: undefined,
    sheaveProfile: undefined,
    ropeDiameter: undefined,
    undercutAngle: undefined,
    vgrooveAngle: undefined,
    grooveDistance: undefined,
    numberOfGrooves: undefined,
}

const actions = {
    async set_tractionSheaveManual_storeAction({ rootState, commit, dispatch }) {
        if (rootState.psgModal.psgMenu == false) {
            try {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                await dispatch('get_deliverTractionSheaveSelection_argument_storeAction');
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                await dispatch('get_machiningForHandWheelSelection_argument_storeAction');
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                await dispatch('get_tractionSheave_DiameterAndWidthSelection_argument_storeAction');
                if (state.showTractionSheaveDetails == true) {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                    await dispatch('get_tractionSheavedetails_storeAction');
                }
            }
            catch { }
            finally {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            }
        }

    },

    // Preselection traction sheave
    async get_deliverTractionSheaveSelection_argument_storeAction({ rootState, commit, dispatch }) {
        var ltr = state.deliverTractionSheave;

        var motorType = rootState.inputsManual.motorType;
        var motorSize = rootState.inputsManual.motorSize;
        var motorPackage = rootState.inputsManual.motorPackage;
        var motorZusatz = rootState.inputsManual.motorZusatz;
        var temperatureMonitoring = rootState.inputsManual.temperatureMonitoring;
        var sM250_TS280 = rootState.inputsManual.sM250_TS280;

        if (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) {
            ltr = rootState.inputsManual.motorManualData.details.ltr;

            motorType = rootState.inputsManual.motorManualData.details.mtyp;
            motorSize = rootState.inputsManual.motorManualData.details.mbg;
            motorPackage = rootState.inputsManual.motorManualData.details.mfe;
            motorZusatz = rootState.inputsManual.motorManualData.details.mzus;
            temperatureMonitoring = rootState.inputsManual.motorManualData.details.msart;
            sM250_TS280 = rootState.inputsManual.motorManualData.details.sM250_TS280;
        }

        const data = {
            motorType: motorType,
            motorSize: motorSize,
            motorPackage: motorPackage,
            motorZusatz: motorZusatz,
            temperatureMonitoring: temperatureMonitoring,
            sM250_TS280: sM250_TS280,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            ltr: ltr,
            pSG_ProdAP: null,
        }
        await dispatch('get_deliverTractionSheaveSelection_storeAction', data)
    },
    get_machiningForHandWheelSelection_argument_storeAction({ rootState, commit, dispatch }) {

        var lthd = state.machiningForHandWheel;
        if (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) {
            lthd = rootState.inputsManual.motorManualData.details.lthd;
        }

        var psg_ProdAP = null;
        if (rootState.psgModal.motorSchModData != null) {
            psg_ProdAP = rootState.psgModal.motorSchModData.psG_ProdAP;
        }

        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            lTHD: lthd,
            pSG_ProdAP: psg_ProdAP,
        }

        dispatch('get_machiningForHandWheelSelection_storeAction', data);
    },
    async get_tractionSheave_DiameterAndWidthSelection_argument_storeAction({ rootState, commit, dispatch }) {

        var tractionSheaveDiameter = (state.tractionsheave_DiameterAndWidth != null && state.tractionsheave_DiameterAndWidth.hasOwnProperty('diameter')) ? state.tractionsheave_DiameterAndWidth.diameter : null;
        var tractionSheaveWidth = (state.tractionsheave_DiameterAndWidth != null && state.tractionsheave_DiameterAndWidth.hasOwnProperty('width')) ? state.tractionsheave_DiameterAndWidth.width : null;
        if (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) {
            tractionSheaveDiameter = rootState.inputsManual.motorManualData.details.td;
            tractionSheaveWidth = rootState.inputsManual.motorManualData.details.tb;
        }


        var motorType = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mtyp : rootState.inputsManual.motorType;
        var motorSize = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mbg : rootState.inputsManual.motorSize;
        var motorPackage = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mfe : rootState.inputsManual.motorPackage;
        var motorZusatz = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mzus : rootState.inputsManual.motorZusatz;
        var temperatureMonitoring = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.msart : rootState.inputsManual.temperatureMonitoring;
        var sM250_TS280 = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.sM250_TS280 : rootState.inputsManual.sM250_TS280;


        var psg_ProdAP = (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null;
        var psg_Voltage = (state.motorSchModData != null) ? state.motorSchModData.psG_Voltage : null;
        var psg_GlobalID_BG = (state.motorSchModData != null) ? state.motorSchModData.psG_GlobalID_BG : null;
        var psg_MotorID = (state.motorSchModData != null) ? state.motorSchModData.psG_MotorID : null;
        var psg_NAM = (state.motorSchModData != null) ? state.motorSchModData.psG_NAM : null;
        var psg_Rillenform = (state.motorSchModData != null) ? state.motorSchModData.psG_Rillenform : null;

        const data = {
            motorType: motorType,
            motorSize: motorSize,
            motorPackage: motorPackage,
            motorZusatz: motorZusatz,
            temperatureMonitoring: temperatureMonitoring,
            sM250_TS280: sM250_TS280,
            kid: rootState.manualHome.kid,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            tractionSheaveDiameter: tractionSheaveDiameter,
            tractionSheaveWidth: tractionSheaveWidth,
            psg_NAM: psg_NAM,
            psg_ProdAP: psg_ProdAP,
            psg_Voltage: psg_Voltage,
            psg_GlobalID_BG: psg_GlobalID_BG,
            psg_MotorID: psg_MotorID,
            psg_Rillenform: psg_Rillenform,
        }
        await dispatch('get_tractionSheave_DiameterAndWidthSelection_storeAction', data);
    },
    async get_deliverTractionSheaveSelection_storeAction({ rootState, commit, dispatch }, value) {
        const data = {
            motorType: value.motorType,
            motorSize: value.motorSize,
            motorPackage: value.motorPackage,
            motorZusatz: value.motorZusatz,
            temperatureMonitoring: value.temperatureMonitoring,
            sM250_TS280: value.sM250_TS280,
            configurationOverviewsManualId: value.configurationOverviewsManualId,
            ltr: value.ltr,
            pSG_ProdAP: value.pSG_ProdAP
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_deliverTractionSheaveSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_LTR_Selection_storeMutation', response.data);
                if (state.deliverTractionSheaveSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.deliverTractionSheaveSelection.findIndex(i => (i.text.code == state.deliverTractionSheave));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_deliverTractionSheave_storeAction', state.deliverTractionSheaveSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.deliverTractionSheaveSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_deliverTractionSheave_storeAction', state.deliverTractionSheaveSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }
                    }
                }
            })
            .catch(() => {
            })
            .then(() => {
            })
    },
    async get_machiningForHandWheelSelection_storeAction({ rootState, commit, dispatch }, value) {
        const data = {
            configurationOverviewsManualId: value.configurationOverviewsManualId,
            lTHD: value.lTHD,
            pSG_ProdAP: value.pSG_ProdAP,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_machiningForHandWheelSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                commit('change_LTHD_Selection_storeMutation', response.data);
                if (state.machiningForHandWheelSelection.length > 0) {
                    var firstIndex_whichMeetConditions = state.machiningForHandWheelSelection.findIndex(i => (i.text.code == state.machiningForHandWheel));
                    if (firstIndex_whichMeetConditions > -1) {
                        dispatch('change_LTHD_storeAction', state.machiningForHandWheelSelection[firstIndex_whichMeetConditions]);
                    }
                    else {
                        firstIndex_whichMeetConditions = state.machiningForHandWheelSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            dispatch('change_LTHD_storeAction', state.machiningForHandWheelSelection[firstIndex_whichMeetConditions]);
                        }
                        else {
                        }

                    }
                }
            })
            .catch(() => {
            })
            .then(() => {

            })
    },
    async get_tractionSheave_DiameterAndWidthSelection_storeAction({ rootState, dispatch }, value) {
        const data = {
            motorType: value.motorType,
            motorSize: value.motorSize,
            motorPackage: value.motorPackage,
            motorZusatz: value.motorZusatz,
            temperatureMonitoring: value.temperatureMonitoring,
            sM250_TS280: value.sM250_TS280,
            kid: value.kid,
            configurationOverviewsManualId: value.configurationOverviewsManualId,
            tractionSheaveDiameter: value.tractionSheaveDiameter,
            tractionSheaveWidth: value.tractionSheaveWidth,
            psg_NAM: value.psg_NAM,
            psg_ProdAP: value.psg_ProdAP,
            psg_Voltage: value.psg_Voltage,
            psg_GlobalID_BG: value.psg_GlobalID_BG,
            psg_MotorID: value.psg_MotorID,
            psg_Rillenform: value.psg_Rillenform,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_tractionSheave_DiameterAndWidthSelection',
            data: {
                data: data,
            }
        })
            .then((response) => {
                dispatch('change_tractionSheave_DiameterAndWidthSelection_storeAction', response.data);
            })
            .catch(() => {
            })
            .then(() => {

            })
    },
    async get_tractionSheavedetails_storeAction({ rootState, commit, dispatch }) {

        var sheaveProfile = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.tarill : state.sheaveProfile;
        var undercutAngle = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.tauwi : state.undercutAngle;
        var vgrooveAngle = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.takwi : state.vgrooveAngle;
        var ropeDiameter = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.tcsd : state.ropeDiameter;
        var grooveDistance = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.tdra : state.grooveDistance;
        var numberOfGrooves = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.tdrz : state.numberOfGrooves;

        var motorType = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mtyp : rootState.inputsManual.motorType;
        var motorSize = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mbg : rootState.inputsManual.motorSize;
        var motorPackage = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mfe : rootState.inputsManual.motorPackage;
        var motorZusatz = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.mzus : rootState.inputsManual.motorZusatz;
        var temperatureMonitoring = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.msart : rootState.inputsManual.temperatureMonitoring;
        var sM250_TS280 = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.sM250_TS280 : rootState.inputsManual.sM250_TS280;
        var lthd = (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) ? rootState.inputsManual.motorManualData.details.lthd : state.machiningForHandWheel;


        var tractionSheaveDiameter = (state.tractionsheave_DiameterAndWidth != null && state.tractionsheave_DiameterAndWidth.hasOwnProperty('diameter')) ? state.tractionsheave_DiameterAndWidth.diameter : null;
        var tractionSheaveWidth = (state.tractionsheave_DiameterAndWidth != null && state.tractionsheave_DiameterAndWidth.hasOwnProperty('width')) ? state.tractionsheave_DiameterAndWidth.width : null;

        if (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.hasOwnProperty('details') && rootState.inputsManual.motorManualData.details.mN_MOT != null) {
            tractionSheaveDiameter = rootState.inputsManual.motorManualData.details.td;
            tractionSheaveWidth = rootState.inputsManual.motorManualData.details.tb;
        }

        const data = {
            tractionSheaveDiameter: tractionSheaveDiameter,
            tractionSheaveWidth: tractionSheaveWidth,
            motorType: motorType,
            motorSize: motorSize,
            motorPackage: motorPackage,
            motorZusatz: motorZusatz,
            temperatureMonitoring: temperatureMonitoring,
            sM250_TS280: sM250_TS280,
            kid: rootState.manualHome.kid,
            lTHD: lthd,
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            sheaveProfile: sheaveProfile,
            undercutAngle: undercutAngle,
            vgrooveAngle: vgrooveAngle,
            ropeDiameter: ropeDiameter,
            grooveDistance: grooveDistance,
            numberOfGrooves: numberOfGrooves,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_tractionSheavedetails',
            data: {
                data: data,
            }
        })
            .then((response) => {
                this.dispatch('statusHandling/change_dataAndStatus_storeAction', response.data);
                if (response.data.status.statusCode.substring(0, 1) == '2') {
                    commit('change_showInfoTractionSheave_storeMutation', false);
                    dispatch('change_tractionSheavedetails_storeAction', response.data.data);
                }
                else {
                }
            })
            .catch(() => {
            })
            .then(() => {
            })

    },

    change_tractionSheave_deliver_setDefaultValues_storeAction({ commit }) {
        commit('change_LTHD_Selection_storeMutation', []);
        commit('change_TARILL_Selection_storeMutation', []);
        commit('change_TCSD_Selection_storeMutation', []);
        commit('change_TDRA_Selection_storeMutation', []);
        this.commit('ropeGuardManual/change_ropeClampSelection_storeMutation', []);
        commit('change_TDRZ_Selection_storeMutation', []);
        commit('change_TAUWI_Selection_storeMutation', []);
        commit('change_TAKWI_Selection_storeMutation', []);
        this.commit('inputsManual/change_tractionSheavedetailsSelection_storeMutation', []);
    },
    change_tractionSheave_DiameterAndWidth_setDefaultValues_storeAction({ commit, dispatch }) {
        commit('change_TARILL_Selected_storeMutation', []);

        commit('change_TAUWI_Selection_storeMutation', []);
        commit('change_TAKWI_Selection_storeMutation', []);
        commit('change_TCSD_Selection_storeMutation', []);
        commit('change_TDRA_Selection_storeMutation', []);
        commit('change_TDRZ_Selection_storeMutation', []);
        this.commit('inputsManual/change_tractionSheavedetailsSelection_storeMutation', []);

        this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
    },
    async change_LTR_Selected_storeAction({ rootState, commit, dispatch }, value) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            await dispatch('change_deliverTractionSheave_storeAction', value);
            if (rootState.psgModal.psgMenu == false) {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                await dispatch('get_machiningForHandWheelSelection_argument_storeAction');
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                await dispatch('get_tractionSheave_DiameterAndWidthSelection_argument_storeAction');
                if (state.showTractionSheaveDetails == true) {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                    await dispatch('get_tractionSheavedetails_storeAction');
                }
            }
            else {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                await this.dispatch('psgModal/get_tractionSheave_DiameterAndWidthSelection_argument_storeAction')
                if (state.showTractionSheaveDetails == true) {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                    await this.dispatch('psgModal/get_SCHMOD_tractionSheavedetails_storeAction');
                }
                if (state.deliverTractionSheave == null || state.deliverTractionSheave == 0) {
                    this.dispatch('statusHandling/change_dataAndStatus_storeAction', { status: { statusCode: '7200001', statusInContextOf: 'checkIf_inputs_areValid_storeAction', statusInformations: [{ textKey: 3724 }], statusModalClosingOptions: [{ displayedDesignation: { textKey: 383 }, closingOption: 'close' }] } })
                }
            }
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }

    },
    async change_deliverTractionSheave_storeAction({ rootState, commit, dispatch }, value) {
        var resetLoader = false;
        if (rootState.inputsManual.motorManualData == null && (value == null || (value.text.text != state.deliverTractionSheave))) {
            await this.dispatch('ropeGuardManual/set_inputManual_RopeGuard_toDefault_storeAction');
        }

        if (value == null) {
            await commit('change_LTR_Selected_storeMutation', null);
        }
        else {
            await commit('change_LTR_Selected_storeMutation', value.text.text);
        }
        var showTractionSheaveDetails = true;
        const firstIndex_whichMeetConditions = state.deliverTractionSheaveSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_LTR_storeMutation', state.deliverTractionSheaveSelection[firstIndex_whichMeetConditions].text.code)
            if (state.deliverTractionSheaveSelection[firstIndex_whichMeetConditions].text.code == 0) {
                showTractionSheaveDetails = false;
                if (rootState.inputsManual.motorManualData == null) {
                    await dispatch('change_tractionSheave_deliver_setDefaultValues_storeAction')
                }
            }
        }
        else {
            await commit('change_LTR_storeMutation', null);
            resetLoader = true;
        }

        await commit('change_showTractionSheaveDetails_storeMutation', showTractionSheaveDetails);
    },
    async change_LTHD_storeAction({ commit, dispatch }, value) {
        var resetLoader = false;
        if (value == null) {
            await commit('change_LTHD_Selected_storeMutation', null);
        }
        else {
            await commit('change_LTHD_Selected_storeMutation', value.text.text);
        }

        const firstIndex_whichMeetConditions = state.machiningForHandWheelSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_LTHD_storeMutation', state.machiningForHandWheelSelection[firstIndex_whichMeetConditions].text.code)
        }
        else {
            await commit('change_LTHD_storeMutation', null)
            resetLoader = true;
        }
    },
    async change_tractionSheave_DiameterAndWidthSelection_storeAction({ commit, dispatch }, value) {
        var resetLoader = false;
        await commit('change_TD_TB_Selection_storeMutation', value);
        const firstIndex_whichMeetConditions = state.tractionSheave_DiameterAndWidthSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await dispatch('change_tractionSheave_DiameterAndWidth_storeAction', state.tractionSheave_DiameterAndWidthSelection[firstIndex_whichMeetConditions])
        }
        else {
            resetLoader = true;
        }
    },
    async change_TD_TB_Selected_storeAction({ commit, dispatch, rootState }, value) {
        try {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
            await dispatch('change_tractionSheave_DiameterAndWidth_storeAction', value);
            if (state.showTractionSheaveDetails == true) {
                if (rootState.psgModal.psgMenu == false) {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                    await dispatch('get_tractionSheavedetails_storeAction');
                }
                else {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
                    await this.dispatch('psgModal/get_SCHMOD_tractionSheavedetails_storeAction');
                }
            }
        }
        catch { }
        finally {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    async change_tractionSheave_DiameterAndWidth_storeAction({ commit, dispatch, rootState }, value) {
        var resetLoader = false;
        if (rootState.inputsManual.motorManualData == null && (value == null ||
            (state.tractionsheave_DiameterAndWidth != null && state.tractionsheave_DiameterAndWidth.hasOwnProperty('diameter') && value.diameter != state.tractionsheave_DiameterAndWidth.diameter ||
                state.tractionsheave_DiameterAndWidth != null && state.tractionsheave_DiameterAndWidth.hasOwnProperty('width') && value.width != state.tractionsheave_DiameterAndWidth.width))) {
            await dispatch('change_tractionSheave_DiameterAndWidth_setDefaultValues_storeAction');
        }
        await commit('change_TD_TB_Selected_storeMutation', value);
        const firstIndex_whichMeetConditions = state.tractionSheave_DiameterAndWidthSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_TD_TB_storeMutation', state.tractionSheave_DiameterAndWidthSelection[firstIndex_whichMeetConditions])
            //if (rootState.inputsManual.motorManualData != null && rootState.inputsManual.motorManualData.details.mN_MOT != null) {
            //}
            //else {
            //    if (state.showTractionSheaveDetails == true) {
            //        if (rootState.psgModal.psgMenu == false) {
            //            await dispatch('get_tractionSheavedetails_storeAction');
            //        }
            //        else {
            //            await this.dispatch('psgModal/get_SCHMOD_tractionSheavedetails_storeAction');
            //        }
            //    }
            //}
        }
        else {
            await commit('change_TD_TB_storeMutation', null)
            resetLoader = true;
        }

        const firstIndex_whichMeetConditions_deliverTractionSheave = state.deliverTractionSheaveSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions_deliverTractionSheave > -1 && state.deliverTractionSheaveSelection[firstIndex_whichMeetConditions_deliverTractionSheave].text.code == 0) {
            this.dispatch('ropeGuardManual/set_ropeGuardManual_storeAction');
        }
    },
    async change_TARILL_storeAction({ commit, dispatch }, value) {
        this.commit('inputsManual/change_tractionSheavedetailsSelection_storeMutation', []);
        await dispatch('change_TAUWI_storeAction', null);
        await dispatch('change_TAKWI_storeAction', null);

        var resetLoader = false;
        if (value == null) {
            await commit('change_TARILL_Selected_storeMutation', null);
        }
        else {
            const valueSelected = {
                arill: value.text.text,
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: state.numberOfGrooves,
            }
            await commit('change_TARILL_Selected_storeMutation', valueSelected);
        }

        const firstIndex_whichMeetConditions = state.sheaveProfileSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_TARILL_storeMutation', state.sheaveProfileSelection[firstIndex_whichMeetConditions].text.text)
            //dispatch('get_tractionSheaveAngleSelection_storeAction')
        }
        else {
            await commit('change_TARILL_storeMutation', null)
            resetLoader = true;
        }

        if (state.vgrooveAngleSelection != null && state.vgrooveAngleSelection.length > 0) {
            const value2 = {
                arill: state.sheaveProfile,
                uwi: state.undercutAngle,
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: state.numberOfGrooves,
            }
            await commit('change_TAKWI_Disabled_storeMuation', value2);
        }

        if (state.undercutAngleSelection != null && state.undercutAngleSelection.length > 0) {
            const value2 = {
                arill: state.sheaveProfile,
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: state.numberOfGrooves,
            }
            await commit('change_TAUWI_Disabled_storeMuation', value2);

            if (state.sheaveProfile != null && state.ropeDiameter != null && state.grooveDistance != null && state.numberOfGrooves != null) {
                const firstIndex_whichMeetConditions_data = state.undercutAngleSelection.findIndex(i => (i.value == state.undercutAngle &&
                    i.disabled == false &&
                    i.arill == state.sheaveProfile &&
                    i.sd == state.ropeDiameter &&
                    i.ra == state.grooveDistance &&
                    i.rz == state.numberOfGrooves));

                if (firstIndex_whichMeetConditions_data > -1) {
                    await dispatch('change_TAUWI_storeAction', state.undercutAngleSelection[firstIndex_whichMeetConditions_data]);
                }
                else {
                    await dispatch('change_TAUWI_storeAction', null);
                }
            }
        }

        if ((state.undercutAngleSelection == null || state.undercutAngleSelection.length == 0 || (state.sheaveProfile != null && state.undercutAngleSelection.findIndex(i => i.arill == state.sheaveProfile) == -1)) &&
            (state.vgrooveAngleSelection == null || state.vgrooveAngleSelection.length == 0 || (state.sheaveProfile != null && state.vgrooveAngleSelection.findIndex(i => i.arill == state.sheaveProfile) == -1))) {
            await this.dispatch('inputsManual/get_tractionSheavedetailsSelection_storeAction', { type: 'zlm', show: false})
        }
    },
    async change_tractionSheavedetails_storeAction({ commit, dispatch }, value) {
        await dispatch('change_tractionSheavedetails_ropeDiameter_storeAction', value.tractionSheavedetails.tractionSheaveRopeDiameterSelection);
        await dispatch('change_tractionSheavedetails_grooveDistance_storeAction', value.tractionSheavedetails.tractionSheaveGrooveDistanceSelection);
        await dispatch('change_tractionSheavedetails_numberOfGroovesSelection_storeAction', value.tractionSheavedetails.tractionSheaveNumberOfRopesSelection);
        await dispatch('change_tractionSheavedetails_sheaveProfileSelection_storeAction', value.tractionSheavedetails.tractionSheaveProfilesSelection);
        await dispatch('change_tractionSheavedetails_undercutAngleSelection_storeAction', value.tractionSheavedetails.tractionSheaveUndercutAngleSelection);
        await dispatch('change_tractionSheavedetails_vgrooveAngleSelection_storeAction', value.tractionSheavedetails.tractionSheaveVgrooveAngleSelection);
        await this.dispatch('inputsManual/get_tractionSheavedetailsSelection_storeAction', { type: 'zlm', show: true })
    },
    async change_tractionSheavedetails_ropeDiameter_storeAction({ commit, dispatch }, value) {
        if (value != null) {
            await commit('change_TCSD_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = state.ropeDiameterSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await commit('change_TCSD_storeMutation', state.ropeDiameterSelection[firstIndex_whichMeetConditions].value);
            }
        } else {
            await commit('change_TCSD_Selection_storeMutation', []);
            await commit('change_showInfoTractionSheave_storeMutation', true);
            await commit('change_TCSD_storeMutation', null);
        }
    },
    async change_tractionSheavedetails_grooveDistance_storeAction({ commit, dispatch }, value) {
        if (value != null) {
            await commit('change_TDRA_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = state.grooveDistanceSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await commit('change_TDRA_storeMutation', state.grooveDistanceSelection[firstIndex_whichMeetConditions].value);
            }
        } else {
            await commit('change_TDRA_Selection_storeMutation', []);
            await commit('change_TDRA_storeMutation', null);
        }
    },
    async change_tractionSheavedetails_numberOfGroovesSelection_storeAction({ commit, dispatch }, value) {
        if (value != null) {
            await commit('change_TDRZ_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = state.numberOfGroovesSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await commit('change_TDRZ_storeMutation', state.numberOfGroovesSelection[firstIndex_whichMeetConditions].value);
            }
        } else {
            await commit('change_TDRZ_Selection_storeMutation', []);
            await commit('change_TDRZ_storeMutation', null);
        }
    },
    async change_tractionSheavedetails_sheaveProfileSelection_storeAction({ commit, dispatch }, value) {
        if (value != null) {
            await commit('change_TARILL_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = state.sheaveProfileSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await commit('change_TARILL_storeMutation', state.sheaveProfileSelection[firstIndex_whichMeetConditions].text.text);
            }
        } else {
            await commit('change_TARILL_Selection_storeMutation', []);
            await commit('change_TARILL_storeMutation', null);
        }
    },
    async change_tractionSheavedetails_undercutAngleSelection_storeAction({ commit, dispatch }, value) {
        if (value != null) {
            await commit('change_TAUWI_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = state.undercutAngleSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await commit('change_TAUWI_storeMutation', state.undercutAngleSelection[firstIndex_whichMeetConditions].value);
            }
        } else {
            await commit('change_TAUWI_Selection_storeMutation', []);
            await commit('change_TAUWI_storeMutation', null);
        }
    },
    async change_tractionSheavedetails_vgrooveAngleSelection_storeAction({ commit, dispatch }, value) {
        if (value != null) {
            await commit('change_TAKWI_Selection_storeMutation', value);
            const firstIndex_whichMeetConditions = state.vgrooveAngleSelection.findIndex(i => (i.selected == true));
            if (firstIndex_whichMeetConditions > -1) {
                await commit('change_TAKWI_storeMutation', state.vgrooveAngleSelection[firstIndex_whichMeetConditions].value);
            }
        } else {
            await commit('change_TAKWI_Selection_storeMutation', []);
            await commit('change_TAKWI_storeMutation', null);
        }
    },

    async change_TCSD_storeAction({ commit, dispatch }, value) {
        var resetLoader = false;
        if (value == null) {
            await commit('change_TCSD_Selected_storeMutation', null);
        }
        else {
            const valueSelected = {
                sd: value.value,
            }
            await commit('change_TCSD_Selected_storeMutation', valueSelected);
        }

        const firstIndex_whichMeetConditions = state.ropeDiameterSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_TCSD_storeMutation', state.ropeDiameterSelection[firstIndex_whichMeetConditions].value)
        }
        else {
            await commit('change_TCSD_storeMutation', null)
            resetLoader = true;
        }

        if (state.grooveDistanceSelection != null && state.grooveDistanceSelection.length > 0) {
            const value2 = {
                sd: state.ropeDiameter,
            }
            await commit('change_TDRA_Disabled_storeMuation', value2);
            if (state.ropeDiameter != null && state.grooveDistance != null) {
                const firstIndex_whichMeetConditions_data = state.grooveDistanceSelection.findIndex(i => (i.value == state.grooveDistance &&
                    i.disabled == false &&
                    i.sd == state.ropeDiameter));

                if (firstIndex_whichMeetConditions_data > -1) {
                    await dispatch('change_TDRA_storeAction', state.grooveDistanceSelection[firstIndex_whichMeetConditions_data]);
                }
                else {
                    var filterdata = state.grooveDistanceSelection.filter(i => (i.disabled == false));
                    if (filterdata != null && filterdata.length == 1) {
                        await dispatch('change_TDRA_storeAction', filterdata[0]);
                    }
                    else {
                        await dispatch('change_TDRA_storeAction', null);
                    }
                }
            }
            else {
                var filterdata = state.grooveDistanceSelection.filter(i => (i.disabled == false));
                if (filterdata != null && filterdata.length == 1) {
                    await dispatch('change_TDRA_storeAction', filterdata[0]);
                }
                else {
                    await dispatch('change_TDRA_storeAction', null);
                }
            }
        }
    },
    async change_TAUWI_storeAction({ commit, dispatch }, value) {
        this.commit('inputsManual/change_tractionSheavedetailsSelection_storeMutation', []);
        var resetLoader = false;
        if (value == null) {
            await commit('change_TAUWI_Selected_storeMutation', null);
        }
        else {
            const valueSelected = {
                arill: state.sheaveProfile,
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: state.numberOfGrooves,
                uwi: value.value,
            }
            await commit('change_TAUWI_Selected_storeMutation', valueSelected);
        }

        const firstIndex_whichMeetConditions = state.undercutAngleSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_TAUWI_storeMutation', state.undercutAngleSelection[firstIndex_whichMeetConditions].value)
        }
        else {
            await commit('change_TAUWI_storeMutation', null)
            resetLoader = true;
        }

        if (state.vgrooveAngleSelection != null && state.vgrooveAngleSelection.length > 0) {
            const value2 = {
                arill: state.sheaveProfile,
                uwi: state.undercutAngle,
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: state.numberOfGrooves,
            }
            await commit('change_TAKWI_Disabled_storeMuation', value2);
            if (state.sheaveProfile != null && state.ropeDiameter != null && state.grooveDistance != null && state.numberOfGrooves != null) {
                const firstIndex_whichMeetConditions_data = state.vgrooveAngleSelection.findIndex(i => (i.value == state.vgrooveAngle &&
                    i.disabled == false &&
                    i.arill == state.sheaveProfile &&
                    i.sd == state.ropeDiameter &&
                    i.ra == state.grooveDistance &&
                    i.rz == state.numberOfGrooves &&
                    i.uwi == state.undercutAngle));

                if (firstIndex_whichMeetConditions_data > -1) {
                    await dispatch('change_TAKWI_storeAction', state.vgrooveAngleSelection[firstIndex_whichMeetConditions_data]);
                }
                else {
                    var filterdata = state.vgrooveAngleSelection.filter(i => (i.disabled == false));
                    if (filterdata != null && filterdata.length == 1) {
                        await dispatch('change_TAKWI_storeAction', filterdata[0]);
                    }
                    else {
                        await dispatch('change_TAKWI_storeAction', null);
                    }
                }

            }
            else {
                var filterdata = state.vgrooveAngleSelection.filter(i => (i.disabled == false));
                if (filterdata != null && filterdata.length == 1) {
                    await dispatch('change_TAKWI_storeAction', filterdata[0]);
                }
                else {
                    await dispatch('change_TAKWI_storeAction', null);
                }
            }
        }
        if (state.undercutAngle != null) {
            const showDetails = (state.undercutAngleSelection != null && state.undercutAngleSelection.length > 0 && state.undercutAngleSelection.findIndex(i => i.selected == true) > -1) ? true : false;
            await this.dispatch('inputsManual/get_tractionSheavedetailsSelection_storeAction', { type: 'zlm', show: showDetails })
        }
    },
    async change_TAKWI_storeAction({ commit, dispatch }, value) {
        this.commit('inputsManual/change_tractionSheavedetailsSelection_storeMutation', []);
        var resetLoader = false;
        if (value == null) {
            await commit('change_TAKWI_Selected_storeMutation', null);
        }
        else {
            const valueSelected = {
                arill: state.sheaveProfile,
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: state.numberOfGrooves,
                uwi: state.undercutAngle,
                kwi: value.value,
            }
            await commit('change_TAKWI_Selected_storeMutation', valueSelected);
        }

        const firstIndex_whichMeetConditions = state.vgrooveAngleSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_TAKWI_storeMutation', state.vgrooveAngleSelection[firstIndex_whichMeetConditions].value)
        }
        else {
            await commit('change_TAKWI_storeMutation', null)
            resetLoader = true;
        }
        if (state.vgrooveAngle != null) {
            const showDetails = (state.vgrooveAngleSelection != null && state.vgrooveAngleSelection.length > 0 && state.vgrooveAngleSelection.findIndex(i => i.selected == true) > -1) ? true : false;
            await this.dispatch('inputsManual/get_tractionSheavedetailsSelection_storeAction', { type: 'zlm', show: showDetails })
        }
    },
    async change_TDRA_storeAction({ commit, dispatch }, value) {
        var resetLoader = false;

        if (value == null) {
            await commit('change_TDRA_Selected_storeMutation', null);
        }
        else {
            const valueSelected = {
                sd: state.ropeDiameter,
                ra: value.value,
            }
            await commit('change_TDRA_Selected_storeMutation', valueSelected);
        }

        const firstIndex_whichMeetConditions = state.grooveDistanceSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_TDRA_storeMutation', state.grooveDistanceSelection[firstIndex_whichMeetConditions].value)
        }
        else {
            await commit('change_TDRA_storeMutation', null)
            resetLoader = true;
        }

        if (state.numberOfGroovesSelection != null && state.numberOfGroovesSelection.length > 0) {
            const value2 = {
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
            }
            await commit('change_TDRZ_Disabled_storeMuation', value2);
            if (state.ropeDiameter != null && state.grooveDistance != null && state.numberOfGrooves != null) {
                const firstIndex_whichMeetConditions_data = state.numberOfGroovesSelection.findIndex(i => (i.value == state.numberOfGrooves &&
                    i.disabled == false &&
                    i.sd == state.ropeDiameter &&
                    i.ra == state.grooveDistance));

                if (firstIndex_whichMeetConditions_data > -1) {
                    await dispatch('change_TDRZ_storeAction', state.numberOfGroovesSelection[firstIndex_whichMeetConditions_data]);
                }
                else {
                    var filterdata = state.numberOfGroovesSelection.filter(i => (i.disabled == false));
                    if (filterdata != null && filterdata.length == 1) {
                        await dispatch('change_TDRZ_storeAction', filterdata[0]);
                    }
                    else {
                        await dispatch('change_TDRZ_storeAction', null);
                    }
                }
            }
            else {
                var filterdata = state.numberOfGroovesSelection.filter(i => (i.disabled == false));
                if (filterdata != null && filterdata.length == 1) {
                    await dispatch('change_TDRZ_storeAction', filterdata[0]);
                }
                else {
                    await dispatch('change_TDRZ_storeAction', null);
                }
            }
        }
    },
    async change_TDRZ_storeAction({ commit, dispatch }, value) {
        var resetLoader = false;
        if (value == null) {
            await commit('change_TDRZ_Selected_storeMutation', null);
        }
        else {
            const valueSelected = {
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: value.value,
            }
            await commit('change_TDRZ_Selected_storeMutation', valueSelected);
        }
        const firstIndex_whichMeetConditions = state.numberOfGroovesSelection.findIndex(i => (i.selected == true));
        if (firstIndex_whichMeetConditions > -1) {
            await commit('change_TDRZ_storeMutation', state.numberOfGroovesSelection[firstIndex_whichMeetConditions].value)
        }
        else {
            await commit('change_TDRZ_storeMutation', null)
            resetLoader = true;
        }

        if (state.sheaveProfileSelection != null && state.sheaveProfileSelection.length > 0) {
            const value2 = {
                sd: state.ropeDiameter,
                ra: state.grooveDistance,
                rz: state.numberOfGrooves,
            }
            await commit('change_TARILL_Disabled_storeMuation', value2);
            if (state.sheaveProfile != null && state.ropeDiameter != null && state.grooveDistance != null && state.numberOfGrooves != null) {
                const firstIndex_whichMeetConditions_data = state.sheaveProfileSelection.findIndex(i => (i.text.text == state.sheaveProfile &&
                    i.disabled == false &&
                    i.sd == state.ropeDiameter &&
                    i.ra == state.grooveDistance &&
                    i.rz == state.numberOfGrooves));

                if (firstIndex_whichMeetConditions_data > -1) {
                    await dispatch('change_TARILL_storeAction', state.sheaveProfileSelection[firstIndex_whichMeetConditions_data]);
                }
                else {
                    var filterdata = state.sheaveProfileSelection.filter(i => (i.disabled == false));
                    if (filterdata != null && filterdata.length == 1) {
                        await dispatch('change_TARILL_storeAction', filterdata[0]);
                    }
                    else {
                        await dispatch('change_TARILL_storeAction', null);
                    }
                }
            }
            else {
                var filterdata = state.sheaveProfileSelection.filter(i => (i.disabled == false));
                if (filterdata != null && filterdata.length == 1) {
                    await dispatch('change_TARILL_storeAction', filterdata[0]);
                }
                else {
                    await dispatch('change_TARILL_storeAction', null);
                }
            }
        }
    },

    set_inputManual_TractionSheave_toDefault_storeAction({ commit }) {
        commit('change_LTR_Selection_storeMutation', []);
        commit('change_LTHD_Selection_storeMutation', []);
        commit('change_TD_TB_Selection_storeMutation', []);
        commit('change_TCSD_Selection_storeMutation', []);
        commit('change_TDRA_Selection_storeMutation', []);
        commit('change_TDRZ_Selection_storeMutation', []);
        commit('change_TARILL_Selection_storeMutation', []);
        commit('change_TAUWI_Selection_storeMutation', []);
        commit('change_TAKWI_Selection_storeMutation', []);
        this.commit('inputsManual/change_tractionSheavedetailsSelection_storeMutation', []);
        commit('change_LTR_storeMutation', null);
        commit('change_showTractionSheaveDetails_storeMutation', null);
        commit('change_LTHD_storeMutation', null);
        commit('change_TD_TB_storeMutation', null);
        commit('change_TCSD_storeMutation', null);
        commit('change_TDRA_storeMutation', null);
        commit('change_TDRZ_storeMutation', null);
        commit('change_TARILL_storeMutation', null);
        commit('change_TAUWI_storeMutation', null);
        commit('change_TAKWI_storeMutation', null);
        commit('change_showInfoTractionSheave_storeMutation', false);
    },
}

const mutations = {
    // Preselection traction sheave
    change_LTR_Selection_storeMutation(state, payload) {
        state.deliverTractionSheaveSelection = payload;
    },
    change_LTHD_Selection_storeMutation(state, payload) {
        state.machiningForHandWheelSelection = payload;
    },
    change_TD_TB_Selection_storeMutation(state, payload) {
        state.tractionSheave_DiameterAndWidthSelection = payload;
    },
    change_TCSD_Selection_storeMutation(state, payload) {
        state.ropeDiameterSelection = payload;
    },
    change_TAUWI_Selection_storeMutation(state, payload) {
        state.undercutAngleSelection = payload;
    },
    change_TAKWI_Selection_storeMutation(state, payload) {
        state.vgrooveAngleSelection = payload;
    },
    change_TDRA_Selection_storeMutation(state, payload) {
        state.grooveDistanceSelection = payload;
    },
    change_TDRZ_Selection_storeMutation(state, payload) {
        state.numberOfGroovesSelection = payload;
    },
    change_TARILL_Selection_storeMutation(state, payload) {
        state.sheaveProfileSelection = payload;
    },
    change_LTR_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.deliverTractionSheaveSelection.length; i++) {
            state.deliverTractionSheaveSelection[i].selected = false;
            if (payload != null && payload != '' && state.deliverTractionSheaveSelection[i].text.text == payload) {
                state.deliverTractionSheaveSelection[i].selected = true;
            }
        }
    },
    change_LTHD_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.machiningForHandWheelSelection.length; i++) {
            state.machiningForHandWheelSelection[i].selected = false;
            if (payload != null && payload != '' && state.machiningForHandWheelSelection[i].text.text == payload) {
                state.machiningForHandWheelSelection[i].selected = true;
            }
        }
    },
    change_TD_TB_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.tractionSheave_DiameterAndWidthSelection.length; i++) {
            state.tractionSheave_DiameterAndWidthSelection[i].selected = false;
            if (payload != null && payload != '' && state.tractionSheave_DiameterAndWidthSelection[i].text == payload.text) {
                state.tractionSheave_DiameterAndWidthSelection[i].selected = true;
            }
        }
    },
    change_TCSD_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.ropeDiameterSelection.length; i++) {
            state.ropeDiameterSelection[i].selected = false;
            if (payload != null && payload != '' && state.ropeDiameterSelection[i].value == payload.sd &&
                state.ropeDiameterSelection[i].disabled == false) {
                state.ropeDiameterSelection[i].selected = true;
            }
        }
    },
    change_TAUWI_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.undercutAngleSelection.length; i++) {
            state.undercutAngleSelection[i].selected = false;
            if (payload != null && payload != '' && state.undercutAngleSelection[i].value == payload.uwi &&
                state.undercutAngleSelection[i].disabled == false &&
                state.undercutAngleSelection[i].sd == payload.sd &&
                state.undercutAngleSelection[i].ra == payload.ra &&
                state.undercutAngleSelection[i].rz == payload.rz &&
                state.undercutAngleSelection[i].arill == payload.arill) {
                state.undercutAngleSelection[i].selected = true;
            }
        }
    },
    change_TAKWI_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.vgrooveAngleSelection.length; i++) {
            state.vgrooveAngleSelection[i].selected = false;
            if (payload != null && payload != '' && state.vgrooveAngleSelection[i].value == payload.kwi &&
                state.vgrooveAngleSelection[i].disabled == false &&
                state.vgrooveAngleSelection[i].sd == payload.sd &&
                state.vgrooveAngleSelection[i].ra == payload.ra &&
                state.vgrooveAngleSelection[i].rz == payload.rz &&
                state.vgrooveAngleSelection[i].arill == payload.arill &&
                state.vgrooveAngleSelection[i].uwi == payload.uwi) {
                state.vgrooveAngleSelection[i].selected = true;
            }
        }
    },
    change_TDRA_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.grooveDistanceSelection.length; i++) {
            state.grooveDistanceSelection[i].selected = false;
            if (payload != null && payload != '' && state.grooveDistanceSelection[i].value == payload.ra &&
                state.grooveDistanceSelection[i].disabled == false &&
                state.grooveDistanceSelection[i].sd == payload.sd) {
                state.grooveDistanceSelection[i].selected = true;
            }
        }
    },
    change_TDRZ_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.numberOfGroovesSelection.length; i++) {
            state.numberOfGroovesSelection[i].selected = false;
            if (payload != null && payload != '' && state.numberOfGroovesSelection[i].value == payload.rz &&
                state.numberOfGroovesSelection[i].disabled == false &&
                state.numberOfGroovesSelection[i].sd == payload.sd &&
                state.numberOfGroovesSelection[i].ra == payload.ra) {
                state.numberOfGroovesSelection[i].selected = true;
            }
        }
    },
    change_TARILL_Selected_storeMutation(state, payload) {
        for (let i = 0; i < state.sheaveProfileSelection.length; i++) {
            state.sheaveProfileSelection[i].selected = false;
            if (payload != null && payload != '' && state.sheaveProfileSelection[i].text.text == payload.arill &&
                state.sheaveProfileSelection[i].sd == payload.sd &&
                state.sheaveProfileSelection[i].ra == payload.ra &&
                state.sheaveProfileSelection[i].rz == payload.rz) {
                state.sheaveProfileSelection[i].selected = true;
            }
        }
    },
    change_LTR_storeMutation(state, payload) {
        state.deliverTractionSheave = payload;
    },
    change_showTractionSheaveDetails_storeMutation(state, payload) {
        state.showTractionSheaveDetails = payload;
    },
    change_LTHD_storeMutation(state, payload) {
        state.machiningForHandWheel = payload;
    },
    change_TD_TB_storeMutation(state, payload) {
        state.tractionsheave_DiameterAndWidth = payload;
    },
    change_TCSD_storeMutation(state, payload) {
        state.ropeDiameter = payload;
    },
    change_TAUWI_storeMutation(state, payload) {
        state.undercutAngle = payload;
    },
    change_TAKWI_storeMutation(state, payload) {
        state.vgrooveAngle = payload;
    },
    change_TDRA_storeMutation(state, payload) {
        state.grooveDistance = payload;
    },
    change_TDRZ_storeMutation(state, payload) {
        state.numberOfGrooves = payload;
    },
    change_TARILL_storeMutation(state, payload) {
        state.sheaveProfile = payload;
    },
    change_TARILL_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.sheaveProfileSelection.length; i++) {
            state.sheaveProfileSelection[i].disabled = false;
            state.sheaveProfileSelection[i].selected = false;

            if (state.sheaveProfileSelection[i].sd != payload.sd ||
                state.sheaveProfileSelection[i].ra != payload.ra ||
                state.sheaveProfileSelection[i].rz != payload.rz ||
                state.sheaveProfileSelection[i].arill != payload.arill ||
                state.sheaveProfileSelection[i].uwi != payload.uwi ||
                state.sheaveProfileSelection[i].kwi != payload.kwi) {
                state.sheaveProfileSelection[i].disabled = true;
            }
        }
    },
    change_TAUWI_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.undercutAngleSelection.length; i++) {
            state.undercutAngleSelection[i].disabled = false;
            state.undercutAngleSelection[i].selected = false;

            if (state.undercutAngleSelection[i].sd != payload.sd ||
                state.undercutAngleSelection[i].ra != payload.ra ||
                state.undercutAngleSelection[i].rz != payload.rz ||
                state.undercutAngleSelection[i].arill != payload.arill) {
                state.undercutAngleSelection[i].disabled = true;
            }
        }
    },
    change_TAKWI_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.vgrooveAngleSelection.length; i++) {
            state.vgrooveAngleSelection[i].disabled = false;
            state.vgrooveAngleSelection[i].selected = false;

            if (state.vgrooveAngleSelection[i].sd != payload.sd ||
                state.vgrooveAngleSelection[i].ra != payload.ra ||
                state.vgrooveAngleSelection[i].rz != payload.rz ||
                state.vgrooveAngleSelection[i].arill != payload.arill ||
                state.vgrooveAngleSelection[i].uwi != payload.uwi) {
                state.vgrooveAngleSelection[i].disabled = true;
            }
        }
    },
    change_TDRA_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.grooveDistanceSelection.length; i++) {
            state.grooveDistanceSelection[i].disabled = false;
            state.grooveDistanceSelection[i].selected = false;

            if (state.grooveDistanceSelection[i].sd != payload.sd) {
                state.grooveDistanceSelection[i].disabled = true;
            }
        }
    },
    change_TDRZ_Disabled_storeMuation(state, payload) {
        for (let i = 0; i < state.numberOfGroovesSelection.length; i++) {
            state.numberOfGroovesSelection[i].disabled = false;
            state.numberOfGroovesSelection[i].selected = false;

            if (state.numberOfGroovesSelection[i].sd != payload.sd ||
                state.numberOfGroovesSelection[i].ra != payload.ra) {
                state.numberOfGroovesSelection[i].disabled = true;
            }
        }
    },
    change_showInfoTractionSheave_storeMutation(state, payload) {
        state.showInfoTractionSheave = payload;
    },
}

const getters = {
    tractionSheaveDiameter: (state, getters, rootState, rootGetters) => {
        return rootState.tractionSheaveManual != null
            && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null
            && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.hasOwnProperty('diameter')
            ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.diameter
            : null;
    },
    tractionSheaveWidth: (state, getters, rootState, rootGetters) => {
        return rootState.tractionSheaveManual != null
            && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth != null
            && rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.hasOwnProperty('width')
            ? rootState.tractionSheaveManual.tractionsheave_DiameterAndWidth.width
            : null;
    },

}

export const tractionSheaveManual = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations
}